import React from "react";
import { motion } from "framer-motion";
import "./About.css";
import profileImage from "../../assets/images/profile.jpg.jpeg";

const About = () => {
  return (
    <main className="profile-page">
      <motion.div 
        className="profile-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Left Column: Image */}
        <aside className="profile-header">
          <img 
            src={profileImage} 
            alt="Gold O. E. Okpa" 
            className="profile-avatar"
          />
        </aside>

        {/* Right Column: Content */}
        <section className="profile-content-wrapper">
          <div className="header-text">
            <h1 className="profile-name">Gold O. E. Okpa</h1>
            <a href="mailto:okpagold@gmail.com" className="header-email">okpagold@gmail.com</a>
          </div>

          <h2 className="profile-question">
            To what extent can AI's ethical design foster unity and well-being across human societies?
          </h2>

          <div className="profile-body">
            <p className="profile-text">
              Currently working as an AI Software Engineer at <a href="https://www.rezonata.xyz/" target="_blank" rel="noopener noreferrer" className="text-link">Rezonata Labs Inc.</a>
            </p>

            <p className="profile-text">
              I am also engaged in AI research and development with <a href="https://oxfordvst.com/index.php" target="_blank" rel="noopener noreferrer" className="text-link">Oxford Vision Studio Technology</a>, contributing to investigative work on computer vision, multi-modal models, and intelligent autonomous systems.
            </p>

            <p className="profile-text">
              Most recently, I contributed to <a href="https://3mtt.org/" target="_blank" rel="noopener noreferrer" className="text-link">3MTT</a>, scaling tech adoption among young Nigerians. Shortly before that, I worked in IT support roles at <a href="https://www.phazecloud.com/" target="_blank" rel="noopener noreferrer" className="text-link">Phaze Cloud</a> and <a href="https://www.abujaelectricity.com/" target="_blank" rel="noopener noreferrer" className="text-link">Abuja Electricity Company</a>.
            </p>

            <p className="profile-text">
              I earned an MSc in Computing from the University of Northampton, building on a background in Electrical & Electronics Engineering (BEng) from Madonna University.
            </p>

            <p className="profile-text">
              My work spans across agentic tools for industrial autonomous systems, healthcare innovation, and IoT. I blend software engineering with operational leadership, driven by a purpose to ensure responsible AI governance.
            </p>
          </div>

          <footer className="profile-footer">
            <div className="footer-links">
              <a href="https://www.linkedin.com/in/gold-okpa-7a7266105" target="_blank" rel="noopener noreferrer" className="link-item">LinkedIn</a>
              <span className="separator">/</span>
              <a href="https://medium.com/@okpagold" target="_blank" rel="noopener noreferrer" className="link-item">Medium</a>
            </div>
          </footer>
        </section>
      </motion.div>
    </main>
  );
};

export default About;
